import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'
import parentsRGBColor from 'helpers/parentColorToRGB'
import { createArraySelector } from 'reselect-map'

const getPrivateLibraryCurrent = state => state.libraries.current
const getLessonsList = state => state.lessons
const getFolders = state => state.folders
const getFoldersColors = state => state.folders.colors
const getPrivateLibraryCurrentParents = state => state.libraries.current.parents

const parentsSelector = createArraySelector(
	[ getPrivateLibraryCurrentParents, getFoldersColors ],
	(parent, colors) => ({
		...parent,
		color: parentsRGBColor(parent, colors),
	})
)

const folderViewSelector = createSelector(
	[getPrivateLibraryCurrent, getLessonsList, getFolders, parentsSelector],
	(current, lessonsList, folders, parents) => {
		let folderColorRGBA
		let library_type_name = ''
		if (current && current.settings && current.settings.entity_type) {
			library_type_name = current.settings.entity_type === 'school' ? localize('private_library_title_schoolLibrary') : localize('private_library_title_districtLibrary')
		}

		if (folders && folders.colors && current) {
			folderColorRGBA = folders.colors.find(color => current.color===color.id)
		}
		const lessons = current.lessons.map(function(id) {
			return lessonsList[id]
		})
		const hasFiltered = !!(current.search.query.applied_keyword || current.search.query.applied_filters.length)
		return {
			lessons,
			hasMore: current.search.more && !!lessons.length,
			folders: current.folders,
			libraryUID: current.libraryUID,
			more: current.search.more,
			init: current.init,
			hasFiltered,
			isRoot: current.folderUID === 0,
			folderUID: current.folderUID,
			library_type_name,
			folderColor: current?current.color:'0',
			folderName: current.name,
			foldersColors: folders.colors,
			folderColorRGBA: folderColorRGBA?folderColorRGBA.color:{r: '184', g: '192', b: '198'},
			parents,
			isSubfolder: current.parents && current.parents.length>1,
			canAddSubfolder: current.parents && current.parents.length<4,
			canMoveFolders: current.parents && current.parents.length<3,
			loading: current.loading,
			banners: current.settings.banners,
			order_field: current.search.query.order_field,
		}
	}
)

export default folderViewSelector
